import { defineMessages } from 'react-intl';

export default defineMessages({
    hasPrefilledLossesHeader: {
        id: 'ml.quoteandbind.pup.disclosures.hasPrefilledLossesHeader',
        defaultMessage: 'We found this information about your home claims'
    },
    hasNoPrefilledLossesHeader: {
        id: 'ml.quoteandbind.pup.disclosures.hasNoPrefilledLossesHeader',
        defaultMessage: 'You entered this information regarding home claims for you'
    },
    date: {
        id: 'ml.quoteandbind.pup.disclosures.Date',
        defaultMessage: 'Date'
    },
    driver: {
        id: 'ml.quoteandbind.pup.disclosures.Driver',
        defaultMessage: 'Driver'
    },
    category: {
        id: 'ml.quoteandbind.pup.disclosures.Category',
        defaultMessage: 'Category'
    },
    description: {
        id: 'ml.quoteandbind.pup.disclosures.Description',
        defaultMessage: 'Description'
    },
    amountPaid: {
        id: 'ml.quoteandbind.pup.disclosures.Amount Paid',
        defaultMessage: 'Amount Paid'
    },
    delete: {
        id: 'ml.quoteandbind.pup.disclosures.Delete',
        defaultMessage: 'Delete'
    },
    additionalLossesDescription: {
        id: 'ml.quoteandbind.pup.disclosures.additionalLossesDescription',
        defaultMessage: 'If there have been any additional claims in the past 5 years, please add them here.'
    },
    additionalIncidentsDescription: {
        id: 'ml.quoteandbind.pup.disclosures.additionalIncidentsDescription',
        defaultMessage: 'If there have been any additional at fault accidents, not at fault accidents, other claims or violations in the past 5 years, please add them here.'
    },
    hasPrefilledIncidentsHeader: {
        id: 'ml.quoteandbind.pup.disclosures.hasPrefilledIncidentsHeader',
        defaultMessage: 'We found this information regarding auto accidents and other claims for drivers in the household'
    },
    hasNoPrefilledIncidentsHeader: {
        id: 'ml.quoteandbind.pup.disclosures.hasNoPrefilledIncidentsHeader',
        defaultMessage: 'You entered this information regarding accidents and other claims for drivers in the household'
    },
    tooltipLabel: {
        id: 'ml.quoteandbind.pup.disclosures.tooltipLabel',
        defaultMessage: 'What if one of the items shown is not mine?'
    },
    tooltipContent: {
        id: 'ml.quoteandbind.pup.disclosures.tooltipContent',
        defaultMessage: 'If one of the items shown is not for you or your household, please contact us by chat. We will advise you on the proof needed to remove the item.'
    },
    addClaim: {
        id: 'ml.quoteandbind.pup.disclosures.Add Claim',
        defaultMessage: 'Add Claim'
    },
    addIncident: {
        id: 'ml.quoteandbind.pup.disclosures.Add Incident',
        defaultMessage: 'Add Incident'
    },
    nextDescription: {
        id: 'ml.quoteandbind.pa.adjustments.nextDescription',
        defaultMessage: 'We\'ll {action} next'
    },
    reviewYourQuote: {
        id: 'ml.quoteandbind.pup.disclosures.review your quote',
        defaultMessage: 'review your quote'
    },
    pageHeader:{
        id:"ml.quoteandbind.pup.disclosures.page-header",
        defaultMessage:"The top section lists your home claims and the bottom section lists your auto accidents and violations."
    }
});
